module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('hr', {
    staticClass: "hr-conta"
  }), _vm._v(" "), _c('hr', {
    staticClass: "hr-cont"
  })]), _c('p', {
    staticClass: "cont-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/author"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/map"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("World Map")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-part"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("PART ONE: A FRESH START")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("1")]), _vm._v(" | 2008: Team of Rivals")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("2")]), _vm._v(" | Foggy Bottom: Smart Power")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-part"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part02"
    }
  }, [_vm._v("PART TWO: ACROSS THE PACIFIC")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch03"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("3")]), _vm._v(" | Asia: The Pivot")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch04"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("4")]), _vm._v(" | China: Uncharted Waters")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("5")]), _vm._v(" | Beijing: The Dissident")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("6")]), _vm._v(" | Burma: The Lady and the Generals")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE: WAR AND PEACE")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("7")]), _vm._v(" | Af-Pak: Surge")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("8")]), _vm._v(" | Afghanistan: To End a War")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("9")]), _vm._v(" | Pakistan: National Honor")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FOUR: BETWEEN HOPE AND HISTORY")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("10")]), _vm._v(" | Europe: Ties That Bind")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("11")]), _vm._v(" | Russia: Reset and Regression")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("12")]), _vm._v(" | Latin America: Democrats and Demagogues")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("13")]), _vm._v(" | Africa: Guns or Growth?")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FIVE: UPHEAVAL")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("14")]), _vm._v(" | The Middle East: The Rocky Path of Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("15")]), _vm._v(" | The Arab Spring: Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("16")]), _vm._v(" | Libya: All Necessary Measures")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("17")]), _vm._v(" | Benghazi: Under Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("18")]), _vm._v(" | Iran: Sanctions and Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("19")]), _vm._v(" | Syria: A Wicked Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("20")]), _vm._v(" | Gaza: Anatomy of a Cease-fire")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART SIX: THE FUTURE WE WANT")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("21")]), _vm._v(" | Climate Change: We’re All in This Together")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("22")]), _vm._v(" | Jobs and Energy: A Level Playing Field")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("23")]), _vm._v(" | Haiti: Disaster and Development")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("24")]), _vm._v(" | 21st-Century Statecraft: Digital Diplomacy in a Networked World")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fontb"
  }, [_vm._v("25")]), _vm._v(" | Human Rights: Unfinished Business")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photographs",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Photographs")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/authorbio",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("About Hillary Rodham Clinton")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/credit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Photo Credits")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2f1bd96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 72
// module chunks = 0